import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PricingCatalog from '../Pricing/PricingCatalog';
import usePricingCheckout from '../Pricing/usePricingCheckout';

export default function TSEPricing() {
  const { t } = useTranslation('pricing');
  const checkout = usePricingCheckout({ successUrl: `${window.location.origin}/sourcing`, cancelUrl: `${window.location.origin}/sourcing` });
  useEffect(() => { document.title = t('titles.tsePricing'); }, [t]);
  return <div className="jsq-pricing-page"><PricingCatalog defaultProduct="tse" products={['tse', 'bundle']}
    onSelectPlan={checkout.selectPlan} pendingPlan={checkout.pendingPlan} error={checkout.error} /></div>;
}
